import ThreatStatusLabel from "../../../../components/ThreatStatusLabel";
import ClassificationSource from "../../../../components/ClassificationSource";
import { AlertDescriptionVariantProps } from "../../@types";
import AlertDescriptionSampleLink from "../AlertDescriptionSampleLink";

const AlertDescriptionClassificationChange = ({
  data,
  linksReloadDocument,
  onLinkClick
}: AlertDescriptionVariantProps) => {
  const sampleLinkPart = (
    <AlertDescriptionSampleLink
      data={data}
      linksReloadDocument={linksReloadDocument}
      onLinkClick={onLinkClick}
    />
  );

  if (data.from_threat_status !== data.threat_status) {
    return (
      <>
        Classification {sampleLinkPart} changed{" "}
        {data.from_threat_status !== null && (
          <>
            from <ThreatStatusLabel threatStatus={data.from_threat_status} />{" "}
          </>
        )}
        to <ThreatStatusLabel threatStatus={data.threat_status} />
        {data.classification_source !== 0 && (
          <>
            {" "}
            via <ClassificationSource value={data.classification_source} />
          </>
        )}
        .
      </>
    );
  } else if (data.from_factor !== data.factor) {
    return (
      <>
        Risk Score {sampleLinkPart} changed from {data.from_factor} to{" "}
        {data.factor}.
      </>
    );
  }
  return (
    <>
      Threat Name {sampleLinkPart} changed from {data.from_threat_name} via{" "}
      <ClassificationSource value={data.classification_source} />.
    </>
  );
};

export default AlertDescriptionClassificationChange;
